import {
  createRouter as createVueRouter,
  createMemoryHistory,
  createWebHistory,
} from "vue-router";
import HomePage from "@/pages/HomePage.vue";
import AboutPage from "@/pages/AboutPage.vue";
import NotFoundPage from "@/pages/404.vue";

const routes = [
  {
    path: "/:slug",
    name: "home",
    component: HomePage,
  },
  {
    path: "/about",
    name: "about",
    component: AboutPage,
  },
  {
    path: "/not-found",
    name: "NotFoundPage",
    component: NotFoundPage,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "NotFoundPage" },
  },
];

const isServer = typeof window === "undefined";

const createRouter = () =>
  createVueRouter({
    history: isServer
      ? createMemoryHistory()
      : createWebHistory(process.env.BASE_URL),
    routes,
  });

export default createRouter;
